import React from "react";
import VendorReportPage from "../component/VendorReportPage";

const VendorReport = () => (
  <div>
    <VendorReportPage />
  </div>
);

export default VendorReport;
